import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { black } from '@avangard/ui/colors';

import { DashboardCard } from '@modules/dashboard/moleculas';
import { EmptyList } from '@modules/layout/icons';

type DashboardChartProps = {
    loading?: boolean;
    empty?: boolean;
    title: string;
    indicator?: string | React.ReactElement;
    children: React.ReactNode;
};

const Root = styled.div`
    width: 100%;
`;

const Wrapper = styled(DashboardCard)``;

const Header = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const Title = styled.div`
    color: ${black[80]};
    font-weight: 600;
    font-size: 14px;
    line-height: 1.4;
    letter-spacing: 0.1px;
`;

const Indicator = styled.div`
    color: ${black[50]};
    text-align: right;
    font-weight: 300;
    font-size: 14px;
    line-height: 1.4;
    letter-spacing: 0.1px;

    strong,
    b {
        color: ${black[80]};
        font-weight: 600;
    }
`;

const Empty = styled.div`
    width: 100%;
    margin: 64px 0 32px;
    text-align: center;

    > p {
        margin-top: 4px;
        font-size: 1.4rem;
        color: ${black[20]};
    }
`;

const DashboardChart = (props: DashboardChartProps): React.ReactElement => {
    const { loading = false, empty = true, title, indicator, children } = props;

    const { t } = useTranslation(['common']);

    return (
        <Root>
            <Wrapper loading={loading}>
                <Header>
                    <Title>{title}</Title>

                    {indicator ? <Indicator>{indicator}</Indicator> : null}
                </Header>

                {empty ? (
                    <Empty>
                        <EmptyList />
                        <p>{t('common:stubs.empty')}</p>
                    </Empty>
                ) : (
                    children
                )}
            </Wrapper>
        </Root>
    );
};

export { DashboardChart };
